<template>
  <div>
    <el-dialog custom-class="my-dialog" title="" :visible.sync="dialogVisible" width="50%" center
      :before-close="handleClose">
      <div style="text-align: center;color: #fff;margin: 20px 0;font-size: 26px;">考试确认窗口</div>

<!--      <div style="background-color: #fff;padding: 20px;font-size: 24px;">
        <div>操作提示：</div>

        <div v-if="typeTxt=='模拟考试'">
          <div class="u-font-20 ">本次考试得分 <span class="e-color-d-1"> {{grade}}</span>分</div>
        </div>
        <div v-if="typeTxt=='精选题库'">
          <div class="u-font-20 ">本次考试答对 <span class="e-color-s-1"> {{realNum}}</span></div>
          <div class="u-font-20 ">本次考试答错 <span class="e-color-d-1"> {{defaultNum}}</span></div>
        </div>

        <div>1.点击【确认交卷】，将提交考试成绩，考试结束</div>
        <div>2.点击【继续考试】，将关闭本窗口，继续考试!</div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="gomis">确认交卷</el-button>
        <el-button type="primary" @click="handleClose">继续考试</el-button>
      </span> -->

      <div style="background-color: #fff;padding: 20px;font-size: 24px;">
        <div>操作提示：</div>

        <div v-if="typeTxt=='模拟考试'">
          <div class="u-font-20 ">本次考试得分 <span class="e-color-d-1"> {{grade}}</span>分</div>
        </div>
        <div v-if="typeTxt=='精选题库'">
          <div class="u-font-20 ">本次考试答对 <span class="e-color-s-1"> {{realNum}}</span></div>
          <div class="u-font-20 ">本次考试答错 <span class="e-color-d-1"> {{defaultNum}}</span></div>
        </div>

        <div v-if="typeTxt=='模拟考试'">考试结束，本次成绩：{{pass}}</div>

      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="gomis">考试记录</el-button>
        <el-button type="primary" @click="handleClose">回到首页</el-button>
      </span>

    </el-dialog>

  </div>
</template>

<script>
  export default {
    name: 'gradeDialog',
    props: {
      dialogVisible: {
        type: Boolean,
        default: false
      },
      typeTxt: {
        type: String,
        default: ''
      },
      list: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        grade: '',
        pass: '',
        realNum: 0,
        defaultNum: 0
      }
    },
    watch: {
      dialogVisible: {
        immediate: true,
        handler(v) {
          if (v) {
            this.get()
          }
        }
      }
    },
    created() {},
    methods: {
      gomis() {
        if (this.typeTxt == '模拟考试') {
          // this.$router.replace('/index')
          this.$router.replace('/home')
        } else {
          this.$router.push('/recode?status=1')
        }
      },
      handleClose() {
          // this.$router.replace('/index')
          this.$router.replace('/home')
      },
      get() {
        if (this.typeTxt == '精选题库') {
          let ask = this.list

          ask.forEach(item => {
            if (item.resultInfo) {
              if (item.resultInfo.pass) {
                this.realNum++
              } else {
                this.defaultNum++
              }
            }
          })

          // this.pass=res.grade>=res.pass?'合格':'不合格'
        }

        if (this.typeTxt == '模拟考试') {
          this.axios('/user/examDetail', {})
            .then(res => {
              this.grade = res.grade
              this.pass = res.grade >= res.pass ? '合格' : '不合格'
            })
            .catch(err => {})
        }
        console.log('this.pass',this.pass)
      }
    }
  }
</script>

<style scoped>
  /* Vue 2 写法 */
  /deep/ .my-dialog.el-dialog {
    background-color: #1d75df;
  }
</style>



// WEBPACK FOOTER //
// src/pages/case/components/gradeDialog.vue